/**
 * Mobile data export — converts web (0-based) format to mobile-compatible JSON.
 */

import type { BibleLocation, Bookmark, Note, PrayerItem } from '@skjv/common';
import { MemoryVerseFrequency } from '@skjv/common';

/** Data sources needed for export */
export interface ExportDataSources {
  bookmarks: Bookmark[];
  notes: Note[];
  prayerItems: PrayerItem[];
  bibleHistory: BibleLocation[];
  memoryVerse: BibleLocation | null;
  memoryVerseFrequency: MemoryVerseFrequency;
}

/** Export user data to mobile-compatible JSON format */
export function exportUserData(sources: ExportDataSources): string {
  const data = {
    bookmarks: sources.bookmarks.map((bm) => ({
      testament: bm.testamentIndex,
      book: bm.bookIndex,
      chapter: bm.chapterIndex,
      verse: bm.verseIndex,
      name: bm.name,
      isFavorite: bm.isFavorite,
    })),
    notes: sources.notes.map((note) => ({
      testament: note.testamentIndex,
      book: note.bookIndex,
      chapter: note.chapterIndex,
      verse: note.verseIndex,
      noteText: note.noteText,
    })),
    prayerItems: sources.prayerItems,
    bibleHistory: sources.bibleHistory.map((loc) => ({
      testament: loc.testamentIndex,
      book: loc.bookIndex,
      chapter: loc.chapterIndex,
      verse: loc.verseIndex,
    })),
    memoryVerse: sources.memoryVerse
      ? {
          testament: sources.memoryVerse.testamentIndex,
          book: sources.memoryVerse.bookIndex,
          chapter: sources.memoryVerse.chapterIndex,
          verse: sources.memoryVerse.verseIndex,
        }
      : null,
    memoryVerseFrequency: sources.memoryVerseFrequency,
    exportedAt: new Date().toISOString(),
  };
  return JSON.stringify(data, null, 2);
}
